import { Button } from "@/components/ui/button.tsx";
import type { ConnectorSummary } from "@/types/connectors.ts";

type Props = { connector: ConnectorSummary };

/**
 * The Teams connector's own action on its card: add okthx to Teams when it
 * isn't installed for this person.
 */
export const TeamsConnectorActions = ({ connector }: Props) => {
  const teams = connector.teams;
  if (!teams || teams.botInstalled || connector.needsAuth) return null;
  return (
    <Button
      variant="outline"
      size="xs"
      asChild
      className="h-6 px-2 text-xs shrink-0"
      data-statsig-name="connectors-teams-add-to-teams"
    >
      <a href={teams.installUrl} target="_blank" rel="noopener noreferrer">
        Add to Teams
      </a>
    </Button>
  );
};
